import { render } from "./OCheckBox.vue?vue&type=template&id=755e053c&scoped=true"
import script from "./OCheckBox.vue?vue&type=script&lang=js"
export * from "./OCheckBox.vue?vue&type=script&lang=js"

import "./OCheckBox.vue?vue&type=style&index=0&id=755e053c&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755e053c"]])

export default __exports__